export const language = {
  zh: {
    'Switch company': '切换公司',
    'Message center': '消息中心',
    'Message': '消息通知',
    'Company link account': '公司关联帐号通知',
    'link to your account, please confirm': '发起关联您的帐号，请确认',
    'Operator': '操作人',
    'initiated link to your account, please confirm': '发起关联您的帐号，请尽快确认！',
    'You have linked': '您已确认关联',
    'You have rejected the link request': '您已拒绝关联',
    'Link rejected': '已拒绝关联',
    'Account link success': '账号关联成功！',
    'All set to read': '全部设为已读',
    'View': '查看',
    'has unlinked your account': '已取消关联您的账号',
    'Refuse': '拒绝',
    'Confirm': '确认关联',
  },
  en: {
    'Switch company': 'Switch company',
    'Message center': 'Message center',
    'Message': 'Message',
    'Company link account': 'Company link account',
    'link to your account, please confirm': 'link to your account, please confirm',
    'Operator': 'Operator',
    'initiated link to your account, please confirm': 'initiated link to your account, please confirm',
    'You have linked': 'You have linked',
    'You have rejected the link request': 'You have rejected the link request',
    'Link rejected': 'Link rejected',
    'Account link success': 'Account link success',
    'All set to read': 'All set to read',
    'View': 'View',
    'has unlinked your account': 'has unlinked your account',
    'Refuse': 'Refuse',
    'Confirm': 'Confirm',
  }
};
